/* eslint-disable */
// import { BellIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom'
import { SplunkLogo } from '@splunk-iteng/splunk-shared-components'

export function SimpleNavBar() {
  return (
    <div className="sticky top-0 z-10 flex h-16 flex-shrink-0 border-b border-gray-200 bg-white">
      <div className="flex flex-1 justify-between px-4 md:px-0">
        <div className="ml-4 flex w-80 md:ml-6">
          <button
            type="button"
            className="rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            <SplunkLogo addClass="h-8 w-auto" />
          </button>
        </div>
        <div className="mr-4 flex items-center md:ml-6">
          <button
            type="button"
            className="bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            <Link to="logout">Log out</Link>
          </button>
        </div>
      </div>
    </div>
  )
}

export default SimpleNavBar
